import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import moment from 'moment';

class ArticleListMeta extends Component {
	getCategoryDetails( cat_id ) {
		if ( 'local' === this.props.catSource ) {
			return this.props.categories.find( category => category.id === cat_id );
		} else {
			return this.props.categories.find( category => category.slug === this.props.match.params.subCategorySlug );
		}
	}

	getCategoryUrl( cat_link ) {
		return 'string' === typeof cat_link
			? cat_link.substring( cat_link.indexOf( '/category' ) )
			: '';
	}

	renderCategories() {
		if ( 'undefined' !== typeof this.props.category_ids ) {
			const categoryDetails = this.getCategoryDetails( this.props.category_ids[ 0 ] );
			if ( 'undefined' !== typeof categoryDetails ) {
				return (
					<a href={ this.getCategoryUrl( categoryDetails.link ) } className="post-category"><span
						dangerouslySetInnerHTML={ { __html: categoryDetails.name } } /></a>
				);
			}
		} else {
			return <span>{ this.props.match.params.subCategorySlug }</span>;
		}

	}

	renderDate( timestamp ) {
		const date = moment( timestamp );
		return (
			       date instanceof moment
		       ) ? date.format( 'MMM D, YYYY' ) : '';
	}

	render() {
		if ( 'undefined' !== typeof this.props.category_ids ) {
			const categoryDetails = this.getCategoryDetails( this.props.category_ids[0] );
			if ( 'undefined' !== typeof categoryDetails && categoryDetails.name.toLowerCase() === 'infohub' ) {
				return <div className="entry-meta">
					{this.renderCategories()}
				</div>;
			} else {
				return <div className="entry-meta">
					<div className="d-flex">
						<div className="entry-category-wrap">
							{ this.renderCategories() }
							<span className="published-date">
								{ this.renderDate( this.props.date ) }
							</span>
						</div>
					</div>
					<div className="d-flex">
						<div className="read-time">
							<svg width="16" height="17" viewBox="0 0 16 17"
							     fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_1480_577)">
									<path
										d="M8 16.5C3.58867 16.5 0 12.9113 0 8.5C0 4.08867 3.58867 0.5 8 0.5C12.4113 0.5 16 4.08867 16 8.5C16 12.9113 12.4113 16.5 8 16.5ZM8 1.83333C4.324 1.83333 1.33333 4.824 1.33333 8.5C1.33333 12.176 4.324 15.1667 8 15.1667C11.676 15.1667 14.6667 12.176 14.6667 8.5C14.6667 4.824 11.676 1.83333 8 1.83333ZM11.3333 8.5C11.3333 8.13133 11.0353 7.83333 10.6667 7.83333H8.66667V4.5C8.66667 4.13133 8.368 3.83333 8 3.83333C7.632 3.83333 7.33333 4.13133 7.33333 4.5V8.5C7.33333 8.86867 7.632 9.16667 8 9.16667H10.6667C11.0353 9.16667 11.3333 8.86867 11.3333 8.5Z"
										fill="#323232"/>
								</g>
								<defs>
									<clipPath id="clip0_1480_577">
										<rect width="16" height="16"
										      fill="white"
										      transform="translate(0 0.5)"/>
									</clipPath>
								</defs>
							</svg>
							<div dangerouslySetInnerHTML={ { __html: categoryDetails.post_read_time } } /> min.read
						</div>
						<div className="bookmark">
							<i className={ `fa-bookmark ${ ISDA_Main.userBookmarks.includes(this.props.post_id) ? 'fa' : 'fa-regular' } toggle-bookmark` } data-post-id={ this.props.post_id }></i>
						</div>
					</div>
				</div>;
			}
		} else {
			return <div className="entry-meta">
				{ this.renderCategories() } | { this.renderDate( this.props.date ) }
			</div>;
		}
	}
}

function mapStateToProps( { categories, catSource } ) {
	return { categories, catSource };
}

export default withRouter( connect( mapStateToProps )( ArticleListMeta ) );